import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'antd';
import { useTranslation } from 'react-i18next';

const PhdThesisCopyModal = ({
  open,
  onCancel,
  onSubmit,
  isSubmitting,
}) => {
  const { t } = useTranslation();

  return (
    <Modal
      open={open}
      title={t('Duplikovať obhájenú tému')}
      okText={t('Duplikovať')}
      cancelText={t('Zrušiť')}
      onCancel={onCancel}
      onOk={onSubmit}
      confirmLoading={isSubmitting}
      maskClosable={false}
    >
      <p>{t('Vznikne nová čakajúca téma v aktuálnom školskom roku.')}</p>
      <p>{t('Novú tému musí pred schválením posúdiť pracovná skupina.')}</p>
    </Modal>
  );
};

PhdThesisCopyModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  isSubmitting: PropTypes.bool,
};

export default PhdThesisCopyModal;
